import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { LifePlan } from '../../../../core/models/lifeplan.interface';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LifeplanService } from '../../../../core/services/lifeplan/lifeplan';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { LifeplanForm } from '../lifeplan-form/lifeplan-form';

@Component({
  selector: 'app-lifeplan-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
  ],
  templateUrl: './lifeplan-list.html',
  styleUrl: './lifeplan-list.scss',
})
export class LifeplanList {
  public page = 1;
  @Input() filtro: string = '';
  @Input() orden: string = '';
  limit = 10;
  total = 0;
  lifeplans: LifePlan[] = [];
  asyncLifeplans!: Observable<LifePlan[]>;
  selectedLifeplan: LifePlan | null = null;
  showColumns: string[] = ['acciones', 'id', 'name', 'code'];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private lifePlanService: LifeplanService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Territorios');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchLifePlan(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchLifePlan(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncLifeplans = this.lifePlanService.getLifeplan(params).pipe(
      tap((data) => {
        this.lifeplans = data.results;
        this.lifePlanService.setLifePlan(data.results[0]);
        this.lifePlanService.setLifePlans(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createLifePlan() {
    this.lifePlanService.removeLifePlanSelected();
    const dialogRef = this.dialog.open(LifeplanForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchLifePlan(this.page);
    });
  }

  updateLifePlan(lifePlan: LifePlan) {
    this.lifePlanService.setLifePlan(lifePlan);
    const dialogRef = this.dialog.open(LifeplanForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchLifePlan(this.page);
    });
  }

  eliminate(lifePlan: LifePlan): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${lifePlan.name}?`);
    if (!confirmed) return;
    this.lifePlanService.delete(lifePlan.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchLifePlan(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
